module.exports = __webpack_public_path__ + "static/media/tablet-android.06f415f4.svg";